module.exports = __webpack_public_path__ + "static/media/report.73797e08.svg";